import { AnyProvider, AutoaddressProvider, PreciselyProvider } from "@/types";
import { startCase } from "lodash-es";
import MapMasterController from "@/components/drawers/right/MapMasterController.vue";
import DataFilters from "@/components/drawers/right/DataFilters.vue";
import SavedSearches from "@/components/drawers/right/SavedSearches.vue";
import BookUploader from "@/components/drawers/right/BookUploader.vue";

const adminRoles = ["GammaAdmin", "Admin"];
const adminRoutes = ["Users", "Organisations"];
const baseProviders = [
  {
    name: "precisely",
    providerType: "PitneyBowes",
    api: {
      base: "https://api.precisely.com/",
      autocomplete: "typeahead/v1/locations",
      geocode: "geocode/v1/premium/geocode",
      reverseGeocode: "geocode/v1/premium/reverseGeocode",
      gamma: "https://build.gamma.ie/Gamma.WS/api/PitneyBowesAuth/GetToken",
    },
    licenceKey: "MqW11-k08u2-hjd6F",
    country: "GBR",
    maxCandidates: 10,
    distance: 500,
  } as PreciselyProvider,
  {
    name: "autoaddress",
    providerType: "AutoAddress",
    licenceKey: "925DD417-9E5F-C066-E96D-E02E50C2850B",
    api: {
      base: "https://api.autoaddress.ie/2.0/",
      findAddress: "findaddress/",
      getEcadData: "getEcadData/",
      getGBPostcodeData: "getgbpostcodedata/",
      getGBBuildingData: "getgbbuildingdata/",
      autocomplete: "autocomplete/",
      reverseGeocode: "reversegeocode/",
      dynamicLicenceKey: "dynamiclicencekey/",
    },
    country: "IE",
  } as AutoaddressProvider,
];

interface TopMenuItem {
  title: string;
  path: string;
  icon: string;
  roles: string[];
}
const menuTop: TopMenuItem[] = [
  {
    path: "/",
    title: "Map",
    icon: "geo-alt",
    roles: [],
  },
  {
    path: "/users",
    icon: "people",
    roles: adminRoles,
  },
  {
    path: "/organisations",
    icon: "briefcase",
    roles: ["GammaAdmin"],
  } /*, {
  path: 'reports',
  icon: 'briefcase'
} */,
].map((i) => ({ ...i, title: i.title || startCase(i.path) }));

export interface RightMenuItem {
  name: string;
  icon: string;
  sidebar: string;
  title: string;
  component?: any;
}

const menuRight: RightMenuItem[] = [
  {
    name: "layers",
    icon: "layers-fill",
    sidebar: "layers",
    title: "Map layers",
    component: MapMasterController,
  },
  {
    name: "filters",
    icon: "clipboard-check",
    sidebar: "filters",
    title: "Data filters",
    component: DataFilters,
  },
  {
    name: "searches",
    icon: "star-fill",
    sidebar: "saved-searches",
    title: "Saved Searches",
    component: SavedSearches,
  },
  {
    name: "Book-upload",
    icon: "book",
    sidebar: "Book-upload",
    title: "Book upload",
    component: BookUploader,
  },
];

interface AppConfig {
  adminRoles: string[];
  adminRoutes: string[];
  baseProviders: AnyProvider[];
  menuRight: RightMenuItem[];
  menuTop: TopMenuItem[];
}

export function useAppConfig(): AppConfig {
  return {
    adminRoles,
    adminRoutes,
    baseProviders,
    menuRight,
    menuTop,
  };
}
